angular.module('impactx.list').directive('ixListFilter', function()
{
    return {
        scope: {
            header: "="
        },
        restrict: 'E',
        templateUrl: 'shared/list/templates/listfilter.tmpl.html',
        transclude: true
    };
});